<template>
  <div>
    <SGPModalComponent
      tamanho="xg"
      titulo="Detalhes"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
    >
      <h3 class="">{{ titulo }}</h3>
      <SGPTabelaComponent
        v-if="headerTabela.length"
        :dados="dadoPorRegional"
        :colunas="headerTabela"
        :usuarioPodeExcluir="false"
        :usuarioPodeEditar="false"
        :somenteLeitura="true"
        dense
        :key="headerTabela.length"
        :customClass="`${classeTabelaSelecionada} tabela-painel-alarmes-por-regional`"
      ></SGPTabelaComponent>
    </SGPModalComponent>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "ModalTabelaPorRegionalComponent",

  props: {
    dados: {
      type: Object,
      required: true
    },
    titulo: {
      type: String,
      required: true
    },
    linha: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      headerTabela: [],
      tabelaSelecionada: 1,
      classeTabelaSelecionada: 'tabelaDadoRegionalPainelAlarmeTabelaUm'
    }
  },

  mounted () {
    this.recuperarHeader()
  },

  computed: {
    ...mapGetters('ctrlRegionais', [
      'listaDeRegionais'
    ]),

    dadoPorRegional () {
      if (this.listaDeRegionais) {
        return this.listaDeRegionais.map(regional => {
          const dadoMesclado = {
            ...regional,
            ...this.dados.regionais[regional.id]
          }
          return dadoMesclado
        })
      }


      return []
    },

    headerTabelaConstrucao () {
      return [
        {
          key: 'regional',
          label: 'Regional',
          sortable: false
        },
        {
          key: 'prazo_construcao_vencer_eh_vencido',
          label: 'Vencido',
          align: 'center',
          sortable: false
        },
        {
          key: 'prazo_construcao_vencer_eh_05',
          label: '5 dias',
          align: 'center',
          sortable: false
        },
        {
          key: 'prazo_construcao_vencer_eh_10',
          label: '10 dias',
          align: 'center',
          sortable: false
        },
        {
          key: 'prazo_construcao_vencer_eh_15',
          label: '15 dias',
          align: 'center',
          sortable: false
        },
        {
          key: 'prazo_construcao_vencer_eh_20',
          label: '20 dias',
          align: 'center',
          sortable: false
        },
        {
          key: 'prazo_construcao_vencer_eh_vazio',
          label: 'Sem Data',
          align: 'center',
          sortable: false
        },
      ]
    },

    headerTabelaAtivacao () {
      return [
        {
          key: 'regional',
          label: 'Regional',
          sortable: false
        },
        {
          key: 'prazo_ativacao_vencer_eh_vencido',
          label: 'Vencido',
          align: 'center',
          sortable: false
        },
        {
          key: 'prazo_ativacao_vencer_eh_05',
          label: '5 dias',
          align: 'center',
          sortable: false
        },
        {
          key: 'prazo_ativacao_vencer_eh_10',
          label: '10 dias',
          align: 'center',
          sortable: false
        },
        {
          key: 'prazo_ativacao_vencer_eh_15',
          label: '15 dias',
          align: 'center',
          sortable: false
        },
        {
          key: 'prazo_ativacao_vencer_eh_20',
          label: '20 dias',
          align: 'center',
          sortable: false
        },
        {
          key: 'prazo_ativacao_vencer_eh_vazio',
          label: 'Sem Data',
          align: 'center',
          sortable: false
        },
      ]
    },

    headerTabelaSLATecnologia () {
      return [
        {
          key: 'regional',
          label: 'Regional',
          sortable: false
        },
        {
          key: 'prazo_tecnologia_vencer_eh_vencido',
          label: 'Vencido',
          align: 'center',
          sortable: false
        },
        {
          key: 'prazo_tecnologia_vencer_eh_05',
          label: '5 dias',
          align: 'center',
          sortable: false
        },
        {
          key: 'prazo_tecnologia_vencer_eh_10',
          label: '10 dias',
          align: 'center',
          sortable: false
        },
        {
          key: 'prazo_tecnologia_vencer_eh_15',
          label: '15 dias',
          align: 'center',
          sortable: false
        },
        {
          key: 'prazo_tecnologia_vencer_eh_20',
          label: '20 dias',
          align: 'center',
          sortable: false
        },
        {
          key: 'prazo_tecnologia_vencer_eh_vazio',
          label: 'Sem Data',
          align: 'center',
          sortable: false
        },
      ]
    },

    headerTabelaAgendado () {
      return [
        {
          key: 'regional',
          label: 'Regional',
          sortable: false
        },
        {
          key: 'prazo_agendado_eh_hoje',
          label: 'Hoje',
          align: 'center',
          sortable: false
        },
        {
          key: 'prazo_agendado_eh_01',
          label: 'Dia 1',
          align: 'center',
          sortable: false
        },
        {
          key: 'prazo_agendado_eh_02',
          label: 'Dia 2',
          align: 'center',
          sortable: false
        },
        {
          key: 'prazo_agendado_eh_03',
          label: 'Dia 3',
          align: 'center',
          sortable: false
        },
        {
          key: 'prazo_agendado_eh_04',
          label: 'Dia 4',
          align: 'center',
          sortable: false
        },
        {
          key: 'prazo_agendado_eh_maior_04',
          label: '> 4 dias',
          align: 'center',
          sortable: false
        },
      ]
    },

    headerTabelaVencido () {
      return [
        {
          key: 'regional',
          label: 'Regional',
          sortable: false
        },
        {
          key: 'prazo_agendado_vencido_eh_01',
          label: 'Dia 1',
          align: 'center',
          sortable: false
        },
        {
          key: 'prazo_agendado_vencido_eh_02',
          label: 'Dia 2',
          align: 'center',
          sortable: false
        },
        {
          key: 'prazo_agendado_vencido_eh_03',
          label: 'Dia 3',
          align: 'center',
          sortable: false
        },
        {
          key: 'prazo_agendado_vencido_eh_04',
          label: 'Dia 4',
          align: 'center',
          sortable: false
        },
        {
          key: 'prazo_agendado_vencido_eh_05',
          label: 'Dia 5',
          align: 'center',
          sortable: false
        },
        {
          key: 'prazo_agendado_vencido_eh_maior_05',
          label: '> 5 dias',
          align: 'center',
          sortable: false
        },
      ]
    }
  },

  methods: {
    fecharModal () {
      setTimeout( () => {
        this.$emit('sgpModalFechar')
      }, 1000) 
    },

    recuperarHeader () {
      if ('construcao' == this.linha) {
        this.headerTabela = this.headerTabelaConstrucao
        return
      }
      if ('ativacao' == this.linha) {
        this.headerTabela = this.headerTabelaAtivacao
        return
      }

      if ('sla_tecnologia' == this.linha) {
        this.headerTabela = this.headerTabelaSLATecnologia
        return
      }

      if ('agendado' == this.linha) {
        this.headerTabela = this.headerTabelaAgendado
         this. classeTabelaSelecionada = ''
        return
      }

      if ('vencido' == this.linha) {
        this.headerTabela = this.headerTabelaVencido
        this. classeTabelaSelecionada = 'tabelaDadoRegionalPainelAlarmeTabelaDois'
        return
      }
      
    }
  },
}
</script>


<style lang="scss">
@import '@/assets/scss/_variables.scss';

  .tabela-painel-alarmes-por-regional {
    thead {
      th:nth-child(1) {
        border-top-left-radius: 10px;
      }
      th:last-child {
        border-top-right-radius: 10px;
      }
    }
  }

  .tabelaDadoRegionalPainelAlarmeTabelaUm {   
    tbody {
      td {
        &:nth-child(2) { background: $bg-vencido; }
        &:last-child { background: #eee; }
      }
    }
  }

  .tabelaDadoRegionalPainelAlarmeTabelaDois {
    tbody {
      td {
        &:nth-child(5), &:nth-child(6), &:last-child { background:  $bg-vencido;; }
      }
    }
  }
  
</style>